import { render } from "./accordion-arrow-icon.vue?vue&type=template&id=308e59d8"
import script from "./accordion-arrow-icon.vue?vue&type=script&lang=js"
export * from "./accordion-arrow-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__